import { useRef, useEffect } from 'react';

/**
 * Returns either a callback or array of callbacks functions that will
 * invoke the supplied callback with the current memeberVars supplied as
 * the first argument:
 * <pre>
 *  function changeModel( { model, onChange, eventData }, evt ) {
 *    const nModel = Model.set( model, evt.data, evt.value )
 *    onChange( { value : nModel, data : eventData })
 *  } 
 * 
 *  function myEditor( props ) {
 *    const [ onChange ] = useInstanceCallback( [ changeModel ], props )
 *    return <ToggleButton onChange={onChange} value={model.value} eventData="value">Armed</ToggleButtton>
 *  }
 * </pre>
 */
export default function useInstanceCallback(callback, ...memberVars) {
  const ref = useRef({
    memberVars
  });
  if (ref.current.cb == null) {
    if (Array.isArray(callback)) {
      ref.current.cb = callback.map(cb => {
        return (...args) => {
          return cb(...ref.current.memberVars, ...args);
        };
      });
    } else {
      ref.current.cb = (...args) => {
        return callback(...ref.current.memberVars, ...args);
      };
    }
  }
  useEffect(() => {
    ref.current.memberVars = memberVars;
  });
  return ref.current.cb;
}